module.exports = __webpack_public_path__ + "img/study-info.c13736f0.png";